import { createRoot } from "react-dom/client"
import registry from "./components/registry.jsx"

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-react-component]").forEach((element) => {
    const name = element.dataset.reactComponent
    const Component = registry[name]

    if (!Component) {
      console.error(`Unknown React component: ${name}`)
      return
    }

    let props = {}
    if (element.dataset.reactProps) {
      try {
        props = JSON.parse(element.dataset.reactProps)
      } catch (error) {
        console.error(`Invalid JSON in data-react-props for ${name}`, error)
      }
    }

    createRoot(element).render(<Component {...props} />)
  })
})
